export default "__VITE_ASSET__Cw0R3h9r__"